import React, {Component} from 'react'
import PropTypes from "prop-types"

class SearchByBarcode extends Component {
    timeout = 0

    _handleChangeInput = (e) => {
        const {value} = e.target

        const {onChange, onSubmit} = this.props

        if (this.timeout) clearTimeout(this.timeout)

        this.timeout = setTimeout(async () => {
            if (typeof onSubmit === 'function' && typeof onChange === 'function') {
                await onChange('barcode', value)
                onSubmit()
            }
        }, 1000)
    }

    render() {
        const {filter} = this.props
        const {barcode} = filter
        
        return (
            <div className="SearchByBarcode mr-3 mb-2">
                <label htmlFor="" className='mb-0 font-weight-bold'>Barcode</label>
                <input value={barcode} onChange={this._handleChangeInput}
                       className="form-control" style={{maxWidth: 140}}
                       placeholder="Nhập barcode..."/>
            </div>
        )
    }
}

SearchByBarcode.propTypes = {
    barcode: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
}

export default SearchByBarcode
